import // getCodeUrl,
// userLoginUrl,
// adminUserUrl,
// validMobileUrl,
// validOpenIdUrl
'Utils/urlUtil';
import {T} from 'Actions/translate';

export default (errorMsg, url, method, params, data) => {
    switch (errorMsg) {
        //CMGT error
        case 'cmgt_error':
        case 'query_price_error':
            // case 'error_price':
            // case 'error_promo_code':
            return T('notification_system_crashed');

        // case 'invalid_quote':
        //     return T('notification_order_promo_invalid')
        // case 'expired_quote':
        //     return T('notification_order_promo_expired')
        // case 'mismatch_quote':
        //     return T('notification_order_promo_mismatch')
        // case 'error_quote':
        //     return T('notification_order_promo_failed')

        //gigya error
        case 'invalid_gigya_token':
            return T('notification_network_unstable');

        // Supply Center system error
        case 'bad_request':
        case 'sql_syntax_error':
        case 'internal_server_error':
        case 'export_error':
            return T('notification_page_error');

        // Other errors
        case 'unauthorized':
            return T('notification_unauthentication');
        case 'permission_denied':
            return T('notification_not_permission');
        case 'invaild_cart_id':
            return T('notification_order_submission_failed');
        case 'invalid_sku':
            return T('notification_invalid_sku');
        case 'invalid_shipToNumber':
            return T('notification_order_submission_failed');
        case 'invalid_mobile':
            return T('notification_invalid_phone');
        case 'invalid_password':
            return T('notification_password_error');
        case 'frozen_shipto_error':
            return T('black_user_not_settle');
        default:
            break;
    }
};
